import styles from './ActionItemSlimCard.module.scss';
import { Icon } from '@mui/material';
import { Text } from '../../components/typography';
import {
  priorityStringLookup,
  statusStringLookup,
} from '../../components/action_items/action_item_utilities';
import classNames from 'classnames';
import Label from '../../components/action_items/Label';
import { useTranslation } from 'react-i18next';
import { getLocalTime } from '../../utilities/time';
import { actionItemIcons } from '../../utilities';
import { useCurrentUser } from '../../providers/UserProvider';

export default function ActionItemSlimCard({
  title,
  priority,
  creator,
  onClick,
  disabled = false,
  status,
  dueDate,
  type,
}) {
  const { t } = useTranslation();
  const { allTemplateTypes } = useCurrentUser();
  return (
    <div
      className={classNames(
        styles.container,
        disabled ? styles.disabled : null,
      )}
      onClick={onClick}
    >
      <div className={classNames(styles.info)}>
        <div className={styles.flexRow}>
          <Icon
            baseClassName="material-icons-outlined"
            sx={{
              color: actionItemIcons(type?.toLowerCase(), allTemplateTypes)
                ?.color,
            }}
          >
            {actionItemIcons(type.toLowerCase(), allTemplateTypes)?.icon ||
              'cancel'}
          </Icon>
          <Text size="md" weight="semiBold" noMargin truncate>
            {title}
          </Text>
        </div>
        <div className={styles.flexRow}>
          <Label
            name={t(statusStringLookup[status]?.title)}
            color={statusStringLookup[status]?.color}
          />
          <Label
            name={t(priorityStringLookup[priority]?.name)}
            color={priorityStringLookup[priority]?.color}
          />
        </div>
      </div>
      <div className={styles.right}>
        <img
          className={styles.avatar}
          src={creator.avatarUrl}
          alt={creator.firstName}
        />
        {!!dueDate && (
          <div className={styles.flexRow}>
            <Icon sx={{ fontSize: '1.2rem' }}>alarm</Icon>
            <Text size="sm" noMargin weight="semiBold" color="secondary">
              {getLocalTime(dueDate).fromNow()}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
}
